import './styles.css';
import StudentProfile from './index.jsx';

export default StudentProfile; 